import React, { Component } from 'react';
import { Button, Card, Col, Divider, Icon, message, Row, Select, Tabs } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import util from '@util/index';
import Statistic from '@comm/statistic/Index';
import { setBackInfo } from '@store/modules/back_info';
import { getAllCompany } from '@store/modules/finance/budget/all_company';

import { queryAccountList } from '@api/core/user';
import { queryFinanceBooksOrg } from '@api/finance/finance';
import {
  queryBatchImportBudgetGroupSet,
  queryBudgetGroupList,
  queryBudgetGroupSum,
  queryDisableBudgetGroup,
  queryEnableBudgetGroup,
  querySaveBudgetGroup,
  querySetBudgetGroupAims,
} from '@api/finance/budget';
import { queryWorkOrg } from '@api/hr/workOrg';
import ModalSetTarget from './ModalSetTarget';
import ModalImport from './ModalImport';
import ModalAdd from './ModalAdd';
import TableOrg from './TableOrg';
import './sp_finance.less';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyAll: [],
      company: [],
      companyEnable: [],
      condition: moment.unix(new Date().getTime() / 1000).format('YYYY'),
      modalAddVisible: false,
      modalTargetVisible: false,
      modalEditVisible: false,
      modalImportVisible: false,
      showFlag: false,
      showProFlag: false,
      importLoading: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { backInfo } = this.props;

    this.loadWorkOrgs();
    this.loadUsers();
    this.loadBook();
    this.loadAllData();

    if (backInfo.path === this.props.location.pathname) {
      this.key = backInfo.key;
      this.setState(
        {
          condition: backInfo.condition,
        },
        () => {
          this.loadData();
          this.loadSum();
          this.loadEnableData();
        },
      );
    } else {
      this.loadData();
      this.loadSum();
      this.loadEnableData();
    }
  }

  componentWillUnmount() {
    const { condition } = this.state;
    const params = {
      path: this.props.location.pathname,
      key: this.key,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  handleEnable = uuid => {
    queryEnableBudgetGroup(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadData();
        this.loadSum();
        this.loadEnableData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleDisable = uuid => {
    queryDisableBudgetGroup(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadData();
        this.loadSum();
        this.loadEnableData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   *获取业务部门列表
   */
  loadWorkOrgs = () => {
    queryWorkOrg({ orgUuid: '' }).then(res => {
      if (res.statusCode === 200) {
        this.workOrgs = res.data;
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 获取用户列表
   */
  loadUsers = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        this.users = res.data;
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 获取资金账户列表
   */
  loadBook = () => {
    queryFinanceBooksOrg().then(res => {
      if (res.statusCode === 200) {
        this.books = res.data;
      } else {
        message.error(res.message);
      }
    });
  };

  loadAllData = () => {
    queryBudgetGroupList({ isEnable: 1 }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          companyAll: this.formatGroup(res.data),
        });
        this.props.dispatch(getAllCompany(res.data));
      } else {
        message.error(res.message);
      }
    });
  };

  loadSum = () => {
    const params = {
      isProject: this.key === '2' ? 1 : 0,
      isEnable: 1,
    };
    const context = this;
    params.year = this.state.condition || '';
    queryBudgetGroupSum(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          sumData: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  loadData = () => {
    const params = {
      isProject: this.key === '2' ? 1 : 0,
      isEnable: 1,
    };
    const context = this;
    params.year = this.state.condition || '';
    this.setState({
      isLoading: true,
    });
    queryBudgetGroupList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          company: this.formatGroup(res.data),
          isLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  loadEnableData = () => {
    const params = {
      isProject: this.key === '2' ? 1 : 0,
      isEnable: 0,
    };
    params.year = this.state.condition || '';
    this.setState({
      isLoading: true,
    });
    queryBudgetGroupList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          companyEnable: this.formatGroup(res.data),
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 递归删除空的children
   */
  formatGroup = arr => {
    arr.map(item => {
      if (item.children) {
        if (item.children.length === 0) {
          delete item.children;
          return item;
        }
        if (item.children.length > 0) {
          this.formatGroup(item.children);
        }
      }
      return item;
    });
    return arr;
  };

  showModalAdd = () => {
    this.setState({
      modalAddVisible: true,
    });
  };

  showModalTarget = flag => {
    this.setState({
      modalTargetVisible: !!flag,
    });
  };

  showModalImport = () => {
    this.setState({
      modalImportVisible: true,
    });
  };

  disableShow = () => {
    const { showFlag } = this.state;
    this.setState({
      showFlag: !showFlag,
    });
  };

  disableProShow = () => {
    const { showProFlag } = this.state;
    this.setState({
      showProFlag: !showProFlag,
    });
  };

  /**
   *
   * 显示编辑账户弹窗
   */
  showModalEdit = uuid => {
    this.uuid = uuid;
    this.setState({
      modalEditVisible: true,
    });
  };

  /**
   * 新增账号
   */
  handAddSubmit = item => {
    item.parentUuid = this.parentUuid;
    querySaveBudgetGroup(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
        this.loadSum();
        this.loadEnableData();
      } else {
        message.error(res.message);
      }
    });
  };

  importBudget = params => {
    this.setState({
      isLoading: true,
      importLoading: true,
    });
    queryBatchImportBudgetGroupSet(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.props.router.push(`/finance/budget/set_manage_mine`);
      } else {
        message.error(res.message);
      }
      this.setState({
        isLoading: false,
        importLoading: false,
      });
    });
  };

  hideModal = () => {
    this.setState({
      modalAddVisible: false,
      modalEditVisible: false,
      modalImportVisible: false,
    });
  };

  handleAdd = parentUuid => {
    this.parentUuid = parentUuid;
  };

  callback = key => {
    this.key = key;
    this.loadData();
    this.loadSum();
    this.loadEnableData();
  };

  // 根据年份生成表
  setCondition = e => {
    this.setState(
      {
        condition: e,
      },
      () => {
        this.loadData();
        this.loadSum();
        this.loadEnableData();
      },
    );
  };

  // 设置年份下拉菜单
  yearss = () => {
    const currentYear = moment.unix(new Date().getTime() / 1000).format('YYYY');
    const {
      backInfo: { condition, path },
    } = this.props;
    const years = [];
    let searchCondition = 0;
    if (path === this.props.location.pathname) {
      searchCondition = condition;
    }

    for (let i = -1; i < 4; i++) {
      years.push(currentYear - i);
    }
    return (
      <Select
        style={{ width: '120px', marginRight: '20px' }}
        placeholder="选择年份"
        onChange={this.setCondition}
        defaultValue={searchCondition || currentYear}
      >
        {years.map(item => (
          <Select.Option key={item}>{item}</Select.Option>
        ))}
      </Select>
    );
  };

  // 设置收入目标
  setBudgetGroupAims = params => {
    this.setState({
      modalTargetVisible: false,
    });
    querySetBudgetGroupAims(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.showModalTarget(false);
        this.loadData();
        this.loadSum();
        this.loadEnableData();
      } else {
        message.error(res.message);
      }
    });
  };

  sumAdujust = () => {
    const { sumData } = this.state;
    let color = '';
    if (sumData && sumData.adjustmentSum > 0) {
      color = 'red';
    } else if (sumData && sumData.adjustmentSum < 0) {
      color = 'green';
    }
    return (
      <span>
        {sumData.adjustmentCount ? (
          <span style={{ color: '#FF9F9F' }}>
            <span style={{ color: '#505659' }}>{'( '}</span>
            {sumData.adjustmentCount}:
            <span style={{ color }}>{util.numberFormat(sumData.adjustmentSum || 0)}</span>
            <span style={{ color: '#505659' }}>{' )'}</span>
          </span>
        ) : (
          ''
        )}
      </span>
    );
  };

  sumFreeze = () => {
    const { sumData } = this.state;
    return (
      <span>
        {sumData.freeze ? (
          <span style={{ color: '#BCBCBC' }}>
            <span style={{ color: '#505659' }}>{'( '}</span>
            冻结{util.numberFormat(sumData.freeze || 0)}
            <span style={{ color: '#505659' }}>{' )'}</span>
          </span>
        ) : (
          ''
        )}
      </span>
    );
  };

  sumConsume = () => {
    const { sumData } = this.state;
    return (
      <span>
        {sumData.freeze ? (
          <span style={{ color: '#BCBCBC' }}>
            <span style={{ color: '#505659' }}>{'( '}</span>
            消耗{util.numberFormat(sumData.consume || 0)}
            <span style={{ color: '#505659' }}>{' )'}</span>
          </span>
        ) : (
          ''
        )}
      </span>
    );
  };

  render() {
    const {
      sumData,

      company,
      companyEnable,

      isLoading,
      importLoading,

      showFlag,
      showProFlag,
    } = this.state;
    const parentProps = {
      company,
      isLoading,
      year: this.state.condition,
      handleAdd: this.handleAdd,
      handleEdit: this.showModalEdit,
      handleEnable: this.handleEnable,
      handleDisable: this.handleDisable,
    };

    return (
      <div className="budget-content">
        <div>
          <Row type="flex" justify="end" style={{ paddingRight: '15px', paddingBottom: '15px' }}>
            <Col>
              {this.yearss()}
              <Button
                icon="plus"
                style={{ marginRight: 8 }}
                onClick={() => this.showModalTarget(true)}
              >
                目标收入
              </Button>
              <Button icon="plus" style={{ marginRight: 8 }} onClick={this.showModalImport}>
                添加预算明细
              </Button>
              <Button icon="plus" style={{ marginRight: 8 }} onClick={this.showModalAdd}>
                添加预算组
              </Button>
            </Col>
            <Col style={{ textAlign: 'right' }} />
          </Row>
        </div>
        <Card>
          {sumData ? (
            <div>
              <Statistic
                data={[
                  {
                    title: '本年预算',
                    value: util.numberFormat(sumData.init || 0),
                    sub: this.sumAdujust(),
                  },
                  {
                    title: '预算余额',
                    value: util.numberFormat(sumData.current || 0),
                    sub: this.sumFreeze(),
                  },
                  {
                    title: '释放',
                    value: util.numberFormat(sumData.release || 0),
                    sub: this.sumConsume(),
                  },
                  {
                    title: '目标收入',
                    value: util.numberFormat(sumData.aim || 0),
                  },
                  {
                    title: '实际收入',
                    value: util.numberFormat(sumData.income || 0),
                  },
                ]}
              />
            </div>
          ) : null}
          <Tabs defaultActiveKey="1" activeKey={this.key || '1'} onChange={this.callback}>
            <TabPane tab="部门预算组" key="1">
              <TableOrg {...parentProps} company={company} />
              <Divider style={{ marginTop: '75px' }}>
                <span className="disableTitle" onClick={this.disableShow}>
                  禁用预算组
                  {showFlag ? (
                    <Icon
                      type="up"
                      style={{
                        fontSize: '10px',
                        paddingLeft: '10px',
                        position: 'relative',
                        top: '-3px',
                      }}
                    />
                  ) : (
                    <Icon
                      type="down"
                      style={{
                        fontSize: '10px',
                        paddingLeft: '10px',
                        position: 'relative',
                        top: '-3px',
                      }}
                    />
                  )}
                </span>
              </Divider>
              {showFlag ? <TableOrg {...parentProps} company={companyEnable} /> : null}
              <div style={{ paddingTop: '100px' }} />
            </TabPane>
            <TabPane tab="项目预算组" key="2">
              <TableOrg {...parentProps} company={company} />
              <Divider style={{ marginTop: '75px' }}>
                <span className="disableTitle" onClick={this.disableProShow}>
                  禁用预算组
                  {showProFlag ? (
                    <Icon
                      type="up"
                      style={{
                        fontSize: '10px',
                        paddingLeft: '10px',
                        position: 'relative',
                        top: '-3px',
                      }}
                    />
                  ) : (
                    <Icon
                      type="down"
                      style={{
                        fontSize: '10px',
                        paddingLeft: '10px',
                        position: 'relative',
                        top: '-3px',
                      }}
                    />
                  )}
                </span>
              </Divider>
              {showProFlag ? <TableOrg {...parentProps} company={companyEnable} /> : null}
              <div style={{ paddingTop: '100px' }} />
            </TabPane>
          </Tabs>
          {this.state.modalImportVisible ? (
            <ModalImport
              cancel={this.hideModal}
              handleSubmit={this.importBudget}
              loading={importLoading}
            />
          ) : null}
          {this.state.modalAddVisible ? (
            <ModalAdd
              handSubmit={this.handAddSubmit}
              data={{}}
              cancel={this.hideModal}
              footer={false}
              title="新增预算组"
              workOrgs={this.workOrgs}
              users={this.users}
              books={this.books}
            />
          ) : null}
          {this.state.modalTargetVisible ? (
            <ModalSetTarget
              handSubmit={this.setBudgetGroupAims}
              data={{
                companyAll: this.state.companyAll,
              }}
              cancel={() => this.showModalTarget(false)}
              title="新建目标收入"
              workOrgs={this.workOrgs}
              users={this.users}
              books={this.books}
            />
          ) : null}
          {this.state.modalEditVisible ? (
            <ModalAdd
              handSubmit={this.handAddSubmit}
              data={{}}
              uuid={this.uuid}
              footer={false}
              title="预算组编辑"
              workOrgs={this.workOrgs}
              users={this.users}
              cancel={this.hideModal}
              books={this.books}
            />
          ) : null}
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  companyAll: state.all_company,
  backInfo: state.back_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/finance/budget/Index.js